import { allCountryCodes } from "@/framework/billing/countries/allCountryCodes";
import { businessCountryCodes } from "@/framework/billing/countries/businessCountryCodes";
import { privateCountryCodes } from "@/framework/billing/countries/privateCountryCodes";
import { BuyerType } from "@/framework/billing/stripe";

const countryNames = new Intl.DisplayNames(["en"], { type: "region" });

// Every country is selectable regardless of buyer type: unsupported
// combinations are handled by pointing the buyer at the contact form rather
// than by hiding the country.
export const countryOptions = allCountryCodes
  .map((countryCode) => ({ countryCode, label: countryLabel(countryCode) }))
  .sort((a, b) => a.label.localeCompare(b.label));

export function isCountryAllowedForBuyerType(
  buyerType: BuyerType,
  countryCode: string,
): boolean {
  const allowed =
    buyerType === "private" ? privateCountryCodes : businessCountryCodes;
  return allowed.has(countryCode);
}

export function countryLabel(countryCode: string): string {
  return `${countryNames.of(countryCode)} (${countryCode})`;
}
